export const MessageConstants = [
    {
        SEVEXITO: 'success',
        SEVINFO:'info',
        SEVERROR:'error',
        SEVWARN:'warn'
    },
    {
        ICONEXITO: 'pi pi-check-circle',
        ICONINFO:'pi pi-info-circle',
        ICONERROR:'pi pi-times-circle',
        ICONWARN:'pi pi-exclamation-triangle'
    },
    {
        MSGEXITOLOGIN: 'Inicio de sesión exitoso.',
        MSGERRORSYSTEM: 'Error en el sistema.',
        MSGWARNLOGIN: 'Usuario o contraseña incorrecta',
        MSGINFOLOGIN: 'Todos los datos son requeridos',
    },
    
];

export const MessageForm = {
    INPUT_REQUIERED: 'El campo es obligatorio.'
}
